import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react"
import type { ProductionMaterialAvailabilityResult } from "../../../api/productionMaterialAvailability"

export function ProductionMaterialAvailabilityWarning({
  result,
  compact = false,
}: {
  result?: ProductionMaterialAvailabilityResult
  compact?: boolean
}) {
  if (!result || result.status !== "shortage") return null
  if (
    !result.components.some(
      (component) =>
        component.status === "shortage" && component.missing_qty > 0,
    )
  ) {
    return null
  }

  return (
    <Alert
      status="warning"
      variant="subtle"
      borderRadius="md"
      mt={compact ? 1 : 3}
      py={compact ? 1 : 2}
      px={compact ? 2 : 3}
      aria-label="Brak materiałów"
      data-testid="production-material-shortage-warning"
      data-material-availability-overlay="true"
    >
      <AlertIcon />
    </Alert>
  )
}

export function ProductionMaterialAvailabilityUnavailable({
  compact = false,
}: {
  compact?: boolean
}) {
  return (
    <Alert
      status="error"
      variant="subtle"
      borderRadius="md"
      mt={compact ? 1 : 3}
      py={compact ? 1 : 2}
      px={compact ? 2 : 3}
      data-testid="production-material-availability-unavailable"
      data-material-availability-overlay="true"
    >
      <AlertIcon />
      <AlertDescription fontSize={compact ? "xs" : "sm"}>
        Nie udało się sprawdzić dostępności materiałów. Spróbuj ponownie.
      </AlertDescription>
    </Alert>
  )
}
